import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  disconnect() {
    this.clearTimer()
  }

  queueSubmit() {
    this.clearTimer()
    this.timer = setTimeout(() => this.element.requestSubmit(), 350)
  }

  clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }
}
